import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { editIcon } from '../../../config/variables';
import { hasPermission, navigateRoute } from '../../../utils/HelperFunctions';
import { IExteriorInteriorColor } from '../types/interfaces';
import { ITableContainerProps } from '../../../types/Interfaces';
import DeleteButton from '../../../components/buttons/DeleteButton';

const ExteriorInteriorColorsTableContainer = ({
  tableHeaders,
  data,
  noDataMessage,
  lessColumns,
  interior
}: ITableContainerProps<IExteriorInteriorColor[]> & { interior?: boolean }) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const type = interior ? 'interior' : 'exterior';

  const hasEditPermission = hasPermission(['colors.edit']);

  return (
    <div className={`table_container ${lessColumns && isDesktop && 'lessColumns'} hasPagination`}>
      <div className="table_header">
        {tableHeaders?.map((header, index) => {
          if (!header) return null;
          return (
            <span className={`head ${header.customClass}`} key={index}>
              {header.label}
            </span>
          );
        })}
      </div>
      <div className={`table_data ${(!data || data?.length === 0) && 'no_data'}`}>
        {data?.length > 0 ? (
          <>
            {data?.map((item, index) => (
              <div
                className={`item ${hasEditPermission && 'clickable'} has_logo body_types`}
                key={index}
                onClick={(e) => {
                  hasEditPermission && navigateRoute(e, `/${type}-colors/create-${type}-color/${item.id}`, navigate);
                }}
              >
                <div className="column">{item?.code || '-'}</div>
                <div className="column">{item?.hexcode || '-'}</div>
                <div className="column">
                  <div className="capitalize">{item?.display_name?.en || '-'}</div>
                </div>
                {hasEditPermission && (
                  <div className="column actions actions_col">
                    <div
                      className="action_btn edit"
                      onClick={(e) => {
                        navigateRoute(e, `/${type}-colors/create-${type}-color/${item.id}`, navigate);
                      }}
                    >
                      {editIcon}
                    </div>
                    <DeleteButton deleteRoute={`/admin/${type}-colors`} queryKey={`${type}-colors`} id={item.id} />
                  </div>
                )}
              </div>
            ))}
          </>
        ) : (
          <h6>{noDataMessage}</h6>
        )}
      </div>
    </div>
  );
};

export default ExteriorInteriorColorsTableContainer;
